import { MultiselectOption } from './multiselect-option.tsx'
import type { MultiselectPopoutOptionProps } from './types.ts'

export const MultiselectPopoutOption = ({
  item,
  virtualItem,
}: MultiselectPopoutOptionProps) => (
  <MultiselectOption item={item} virtualItem={virtualItem} />
)
